<template>
  <div>
    <v-card :loading="loading" outlined :style="$store.state.isMobile?'margin-bottom: 100px': ''">
      <v-toolbar class="pl-0" dense flat color="transparant">
        <v-subheader>{{$t("markers")}}</v-subheader>
        <v-spacer></v-spacer>
        <v-btn v-if="!blueprintFile.content" color="primary" @click="addMarker" dark small icon>
          <v-icon>add</v-icon>
        </v-btn>
        <v-btn v-if="$store.state.isMobile && blueprintFile.content" color="primary" @click="openBlueprint" dark small icon>
          <v-icon>add</v-icon>
        </v-btn>
        <v-menu
          transition="scale-transition"
          origin="right top"
          style="z-index: 10"
          class="white"
          :close-on-content-click="false"
          bottom
          left
        >
          <template v-slot:activator="{ on }">
            <v-btn color="primary" icon v-on="on">
              <v-icon>fa-info-circle</v-icon>
            </v-btn>
          </template>
          <v-sheet flatwidth="600px" height="180px">
            <v-list dense>
              <v-list-item>
                <v-list-item-icon>
                  <v-icon color="red">priority_high</v-icon>
                </v-list-item-icon>
                <v-list-item-content>{{$t('info_broken')}}</v-list-item-content>
              </v-list-item>
              <v-list-item>
                <v-list-item-icon>
                  <v-icon color="orange">priority_high</v-icon>
                </v-list-item-icon>
                <v-list-item-content>{{$t('info_inProcess')}}</v-list-item-content>
              </v-list-item>
              <v-list-item>
                <v-list-item-icon>
                  <v-icon color="success">check_circle</v-icon>
                </v-list-item-icon>
                <v-list-item-content>{{$t('info_approved')}}</v-list-item-content>
              </v-list-item>
              <v-list-item>
                <v-list-item-icon>
                  <v-icon color="primary">priority_high</v-icon>
                </v-list-item-icon>
                <v-list-item-content>{{$t('info_new')}}</v-list-item-content>
              </v-list-item>
            </v-list>
          </v-sheet>
        </v-menu>
        <v-menu
          transition="scale-transition"
          origin="right top"
          style="z-index: 10"
          class="white"
          :close-on-content-click="false"
          bottom
          left
        >
          <template v-slot:activator="{ on }">
            <v-btn color="primary" icon v-on="on">
              <v-icon>mdi-dots-vertical</v-icon>
            </v-btn>
          </template>
          <v-sheet flat width="200px" height="180px">
            <v-checkbox :hide-details="true" v-model="markerStatus" class="ml-2 mt-0" :value="4">
              <template slot="label">
                <v-icon color="primary">select_all</v-icon>
                {{$t('showAll')}}
              </template>
            </v-checkbox>
            <v-checkbox :hide-details="true" class="ml-2 mt-0" v-model="markerStatus" :value="0">
              <template slot="label">
                <v-icon color="red">priority_high</v-icon>
                {{$t('broken')}}
              </template>
            </v-checkbox>
            <v-checkbox :hide-details="true" class="ml-2 mt-0" v-model="markerStatus" :value="1">
              <template slot="label">
                <v-icon color="orange">priority_high</v-icon>
                {{$t('inProcess')}}
              </template>
            </v-checkbox>
            <v-checkbox :hide-details="true" class="ml-2 mt-0" v-model="markerStatus" :value="2">
              <template slot="label">
                <v-icon color="success">check_circle</v-icon>
                {{$t('approved')}}
              </template>
            </v-checkbox>
            <v-checkbox :hide-details="true" class="ml-2 mt-0" v-model="markerStatus" :value="3">
              <template slot="label">
                <v-icon color="primary">priority_high</v-icon>
                {{$t('new')}}
              </template>
            </v-checkbox>
          </v-sheet>
        </v-menu>
      </v-toolbar>
      <v-divider></v-divider>
      <v-text-field
        v-model="search"
        clearable
        flat
        dense
        solo
        hide-details
        prepend-inner-icon="search"
        :label="$t('search')"
        @click:clear="search = ''"
      ></v-text-field>
      <v-divider></v-divider>
      <swipe-list :items="filteredItems" item-key="id">
        <template v-slot="{ item}">
          <v-card
            v-bind:style="{ display: filterMarkers(item) }"
            v-bind:class="{'active-row': (item.draggable)}"
            @dblclick="markerDetails(item)"
            @click="select(item)"
            class="v-card card-content"
          >
            <v-card-title class="py-2">
              {{item.number}}
              <template v-if="item.label">- {{item.label}}</template>
            </v-card-title>
            <v-card-text class="py-0">
               <p class="caption mb-0">
              <template v-if="item.date">{{$t('applicationDate')}} {{item.date}}</template> 
              <br>
              <template
                  v-if="item.installer"
                >{{$t('modifiedBy')}} {{item.installer.firstname}} {{item.installer.name}}
                {{item.modifiedTs}}
                </template>
            </p>
              <p class="caption mb-0 text-truncate">{{item.comments}}</p>
            </v-card-text>
            <v-card-actions>
              <template v-if="item.qrId">
                <v-chip>
                  <v-icon small class="mr-2" color="secondary">fa-qrcode</v-icon>
                  <template v-if="$vuetify.breakpoint.mdAndUp">{{$t('linked')}}</template>
                </v-chip>
              </template>
              <template v-else>
                <v-chip>
                  <v-icon small class="mr-2" color="error">fa-qrcode</v-icon>
                  <template v-if="$vuetify.breakpoint.mdAndUp">{{$t('notLinked')}}</template>
                </v-chip>
              </template>
              <v-chip>
                <v-icon
                  :color="item.status == 0? 'red' :
                     item.status == 1  ? 'orange':
                      item.status == 2? 'success': 'primary'"
                >{{item.status == 2 ? 'check_circle' : item.status === 1 ? 'priority_high': 'priority_high'}}</v-icon>
                {{item.status == 0 ? $t('broken') : item.status == 2 ? $t('approved') : item.status == 1 ? $t('inProcess') : $t('new') }}
              </v-chip>
              <v-spacer></v-spacer>
              <v-btn color="secondary" text @click="markerDetails(item)">{{$t('open')}}</v-btn>
            </v-card-actions>
            <v-divider></v-divider>
          </v-card>
        </template>
        <template v-if="$can('delete','markers') && !$store.state.isOffline" v-slot:right="{ item}">
          <div class="swipeout-action red" title="remove">
            <areyousure
              v-on:delete="deleteMarker"
              :icon="true"
              color="white"
              :id="item.id"
              object="marker"
            ></areyousure>
          </div>
        </template>
      </swipe-list>
      <v-card v-if="$store.state.markers.length == 0" flat>
        <template v-if="$store.state.drawable">
          <p class="text-center pa-5 body-1 font-weight-light">
            <span>
              <!-- <v-icon color="primary">info</v-icon> -->
              {{$t('draw')}}
            </span>
          </p>
        </template>
        <div
          v-else
          @click="blueprintFile.content ?setDrawable() : addMarker()"
          v-ripple
          class="text-center pa-5 body-1 font-weight-light"
        >
          <v-btn icon>
            <v-icon x-large color="primary">add_circle_outline</v-icon>
          </v-btn>
        </div>
      </v-card>
    </v-card>
  </div>
</template>


<script>
import uuid from "uuid";
import { SwipeList, SwipeOut } from "vue-swipe-actions";
import "vue-swipe-actions/dist/vue-swipe-actions.css";

export default {
  name: "markers",
  props: {
    blueprintFile: Object,
  },
  components: {
    SwipeOut,
    SwipeList,
  },
  data() {
    return {
      search: "",
      showDelete: false,
      selected: undefined,
      headers: [
        {
          text: this.$t("marker"),
          align: "left",
          value: "number",
        },
        {
          text: this.$t("status"),
          align: "left",
          value: "isApproved",
        },
        { text: "Actions", sortable: false },
      ],
      loading: false,
      markerStatus: [4],
    };
  },
  methods: {
    filterMarkers(marker) {
      return (marker.status == 1 && this.markerStatus.includes(1)) ||
        (marker.status == 0 && this.markerStatus.includes(0)) ||
        (marker.status == 3 && this.markerStatus.includes(3)) ||
        (marker.status == 2 && this.markerStatus.includes(2)) ||
        this.markerStatus.includes(4)
        ? "inherit"
        : "none";
    },
    openBlueprint() {
      this.$store.state.openBlueprint = true;
      this.$store.state.drawable = true;
    },
    addMarker() {
      this.$store.state.markersReadonly = [];
      let newMarker = {
        id: uuid.v4(),
        coordX: 24,
        coordY: 34,
        coordX2: 117,
        coordY2: 110,
        //just not all in a corner
        BluePrintId: this.$route.params.id,
        attachments: [],
        markerXSolutions: [],
      };
      if (this.$store.state.isOffline) {
        this.$noty.warning(this.$t("cached"));
        newMarker.number =
          this.$store.getters.markers.length == 0
            ? 1
            : Math.max.apply(
                Math,
                this.$store.getters.markers.map((x) => x.number)
              ) + 1;
        newMarker.new = true;

        // this.$store.commit("offAddAndSetUIelements", newMarker);
        this.$store.commit("AddAndSetUIelements", newMarker);

        let offForm = {
          marker: newMarker,
        };
        this.$store.commit("addOrUpdateOffForm", offForm);
        // this.addMarkerToDb(newMarker)
      } else {
        this.$http
          .addMarker(newMarker)
          .then((res) => {
            this.$store.commit("AddAndSetUIelements", res.data);
            this.$noty.success('<i class="fas fa-check"></i>');
            //this.$store.state.drawable = true;
          })
          .catch((err) => {
            this.$noty.error(this.$t("error"));
            console.log(err);
          });
      }
    },
    setDrawable() {
      if (!this.$store.state.drawable) this.$store.state.drawable = true;
    },
    deleteMarker(id) {
      this.$store.state.markers = this.$store.state.markers.filter(
        (p) => p.id != id
      );
      this.$store.state.markersReadonly = [];
    },
    markerDetails(marker) {
      this.select(marker);
      this.$emit("showMarkerDetails", marker);
    },
    select(item) {
      item.draggable = true;
      this.$store.commit("select", item);
    },
    getMarkers(light = false) {
      this.$http
        .getMarkers(this.$route.params.id, light)
        .then((res) => {
          this.loading = false;
          console.log("Loading store...");
          let markers = [];
          //adding the markerui fields here..
          res.data.forEach((element) => {
            this.$store.commit("AddAndSetUIelements", element);
          });
          if(!light) this.$store.state.readyForOffline = true
          
          console.log(
            "Store markers has " + this.$store.state.markers.length + " items"
          );
        })
        .catch((err) => console.log(err));
    },
  },
  computed: {
    markers() {
      return this.$store.getters.markers;
    },
    filteredItems() {
      return this.$store.getters.markers.filter((item) => {
        return item.label
          ? item.label.toLowerCase().includes(this.search.toLowerCase())
          : "" ||
              item.number
                .toString()
                .toLowerCase()
                .includes(this.search.toLowerCase());
      });
    },
  },
  watch: {
    markers(after, before) {},
    markerStatus(n, o) {
      if (n.length > 1) {
        if (n[n.length - 1] === 4) {
          this.markerStatus = [4];
        } else {
          if (n.includes(4)) {
            this.markerStatus = this.markerStatus.filter((x) => x != 4);
          }
        }
      }
    },
  },
  created() {
    this.loading = true;
    if (!this.$store.state.isOffline) {
      
      if (
        this.$store.state.markers.find(
          (x) => x.blueprintId == this.$route.params.id
        )
      ) {
        //if coming from marker details,
        if (this.$store.state.markers.length <= 1) {
          this.$store.state.markers = [];
          if (!this.$store.state.isOffline) {
            this.getMarkers();
          }
        } else {
          this.loading = false;
          
        }
      } else {
        //if blueprint has changed, empty list
        this.$store.state.markers = [];

        this.getMarkers();
      }
    } else {
      this.loading = false;
    }
  },
};
</script>


<style>
a:not(.md-button):hover {
  text-decoration: unset !important;
}
</style>
<style scoped>
.list-installer {
  max-height: 600px;
  overflow-y: auto;
}
</style>

<style >
.marker_item_wrapper {
  display: grid;
  grid-template-columns: 1fr 1fr 1fr 1fr 1fr 1fr;
  grid-template-areas: "main main main main icons icons";
  grid-gap: 2rem;
  min-height: 88px;
  max-height: 88px;
  overflow: hidden;
}
.marker_main_info {
  grid-area: main;
  overflow: hidden;
  display: -webkit-box;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical !important;
}
.marker_main_info > p {
  overflow: hidden;
}

.marker_icons {
  grid-area: icons;
  display: flex;
  align-items: right;
  justify-content: end;
}
.marker_list_wrapper {
  padding: 0 16px;
  padding-top: 0px;
  padding-right: 16px;
  padding-bottom: 0px;
  padding-left: 16px;
}
</style>


<style scoped>
.swipeout-action {
  display: flex;
  align-items: center;
  padding: 0 3rem;
  cursor: pointer;
  left: 0;
}
</style>


// WEBPACK FOOTER //
// src/components/pages/Markers/Edit/List.vue